let swup

(async () => {
    // Dynamically import gsap and its ScrollTrigger plugin
    const {gsap} = await import("gsap");
    const {ScrollToPlugin} = await import ('gsap/ScrollToPlugin');
    const {ScrollTrigger} = await import("gsap/ScrollTrigger");
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    // Dynamically import Swup and its plugins
    const {default: Swup} = await import("swup");
    const {default: SwupHeadPlugin} = await import("@swup/head-plugin");
    const {default: SwupA11yPlugin} = await import("@swup/a11y-plugin");
    const {default: SwupScriptsPlugin} = await import("@swup/scripts-plugin");
    const {default: SwupMorphPlugin} = await import("swup-morph-plugin");
    const {default: SwupPreloadPlugin} = await import("@swup/preload-plugin");
    const {default: SwupParallelPlugin} = await import("@swup/parallel-plugin");
    const {default: SwupProgressPlugin} = await import("@swup/progress-plugin");
    const {default: SwupScrollPlugin} = await import("@swup/scroll-plugin");

    swup = new Swup({
        containers: ["main.page"],
        plugins: [
            new SwupHeadPlugin({
                persistAssets: true,
                awaitAssets: true,
                persistTags: '[data-keep]'
            }),
            new SwupA11yPlugin(),
            new SwupScriptsPlugin(),
            new SwupMorphPlugin({
                containers: ['.navigation']
            }),
            new SwupParallelPlugin({}),
            new SwupProgressPlugin(),
            new SwupPreloadPlugin({
                preloadHoveredLinks: true,
                preloadVisibleLinks: false,
                preloadInitialPage: false
            }),
            new SwupScrollPlugin({
                offset: 20
            })
        ],
        announcements: {
            'en-US': {visit: 'Navigated to: {title}', url: 'New page at {url}'},
            'de-DE': {visit: 'Navigiert zu: {title}', url: 'Neue Seite unter {url}'},
            'fr-FR': {visit: 'Navigué vers : {title}', url: 'Nouvelle page à {url}'},
            '*': {visit: '{title}', url: '{url}'}
        }
    });

    swup.hooks.on('visit:start', (context) => {
        let x = 0.5;
        let y = 0.5;

        const event = context.trigger.event;
        if (event && typeof event.clientX === 'number') {
            x = event.clientX;
            y = event.clientY;
        }

        document.documentElement.style.setProperty('--transition-x', `${x}px`);
        document.documentElement.style.setProperty('--transition-y', `${y}px`);
    });

    swup.hooks.on("content:replace", () => {
        const videos = document.querySelectorAll('video[autoplay]');
        videos.forEach(video => {
            video.muted = true;
        });
    });

    /*
     * Overwrite swup's scrollTo function 
     */
    swup.scrollTo = (offsetY, animate = true) => {
        if (!animate) {
            swup.hooks.callSync('scroll:start', undefined);
            window.scrollTo(0, offsetY);
            swup.hooks.callSync('scroll:end', undefined);
            return;
        }

        gsap.to(window, {
            duration: 0.8,
            scrollTo: offsetY,
            ease: 'power4.inOut',
            onStart: () => {
                swup.hooks.callSync('scroll:start', undefined);
            },
            onComplete: () => {
                swup.hooks.callSync('scroll:end', undefined);
            },
        });
    };

})();

export default async () => {
    // Ensure swup is initialized before exporting
    while (!swup) {
        await new Promise((resolve) => setTimeout(resolve, 10));
    }
    return swup;
};
